// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foliage_App_Style from "../Foliage.App.Style/index.js";
import * as Halogen_Component from "../Halogen.Component/index.js";
import * as Halogen_HTML from "../Halogen.HTML/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_Query_HalogenM from "../Halogen.Query.HalogenM/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM);
var modify_ = /* #__PURE__ */ Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM);
var AddLog = /* #__PURE__ */ (function () {
    function AddLog(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AddLog.create = function (value0) {
        return function (value1) {
            return new AddLog(value0, value1);
        };
    };
    return AddLog;
})();
var SetLogs = /* #__PURE__ */ (function () {
    function SetLogs(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetLogs.create = function (value0) {
        return function (value1) {
            return new SetLogs(value0, value1);
        };
    };
    return SetLogs;
})();
var ShowIntermediateEnv = /* #__PURE__ */ (function () {
    function ShowIntermediateEnv(value0) {
        this.value0 = value0;
    };
    ShowIntermediateEnv.create = function (value0) {
        return new ShowIntermediateEnv(value0);
    };
    return ShowIntermediateEnv;
})();
var HideIntermediateEnv = /* #__PURE__ */ (function () {
    function HideIntermediateEnv() {

    };
    HideIntermediateEnv.value = new HideIntermediateEnv();
    return HideIntermediateEnv;
})();
var MouseEnterLogHeader = /* #__PURE__ */ (function () {
    function MouseEnterLogHeader(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MouseEnterLogHeader.create = function (value0) {
        return function (value1) {
            return new MouseEnterLogHeader(value0, value1);
        };
    };
    return MouseEnterLogHeader;
})();
var MouseLeaveLogHeader = /* #__PURE__ */ (function () {
    function MouseLeaveLogHeader(value0) {
        this.value0 = value0;
    };
    MouseLeaveLogHeader.create = function (value0) {
        return new MouseLeaveLogHeader(value0);
    };
    return MouseLeaveLogHeader;
})();
var component = /* #__PURE__ */ (function () {
    var renderLog = function (v) {
        return Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.flex_column)([  ])) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.bold)([ "background-color: rgba(0, 0, 0, 0.2)" ])), Halogen_HTML_Events.onMouseEnter(MouseEnterLogHeader.create(v.value1)), Halogen_HTML_Events.onMouseLeave(MouseLeaveLogHeader.create) ])([ Halogen_HTML_Core.text(v.value0.label) ]), Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.flex_column)([ "padding-left: 1.0em", "gap: 1em" ])) ])(map(function (v1) {
            return Halogen_HTML.fromPlainHTML(Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_row) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.underline)([ "flex-shrink: 0", "padding-right: 0.2em", "width: 8em", "text-align: right", "border-right: 1px solid black" ])) ])(pure(Halogen_HTML_Core.text(v1.value0))), v1.value1 ]));
        })(v.value0.messages)) ]);
    };
    var render = function (state) {
        return Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.flex_column)(append(Foliage_App_Style.font_code)([ "gap: 1.0em" ]))) ])([ Halogen_HTML_Elements.div([ Foliage_App_Style.style(Foliage_App_Style.flex_row) ])([ Halogen_HTML_Elements.button([ Foliage_App_Style.style(Foliage_App_Style.button) ])([ Halogen_HTML_Core.text("Clear") ]) ]), Halogen_HTML_Elements.div([ Foliage_App_Style.style(append(Foliage_App_Style.padding_small)(append(Foliage_App_Style.flex_column)([ "gap: 2em", "overflow: scroll" ]))) ])(mapFlipped(state.logs)(renderLog)) ]);
    };
    var initialState = function (input) {
        return {
            logs: [  ]
        };
    };
    var handleQuery = function (v) {
        if (v instanceof AddLog) {
            return discard(modify_(function (state) {
                var $22 = {};
                for (var $23 in state) {
                    if ({}.hasOwnProperty.call(state, $23)) {
                        $22[$23] = state[$23];
                    };
                };
                $22.logs = Data_Array.snoc(state.logs)(v.value0);
                return $22;
            }))(function () {
                return pure1(new Data_Maybe.Just(v.value1));
            });
        };
        if (v instanceof SetLogs) {
            return discard(modify_(function (v1) {
                var $27 = {};
                for (var $28 in v1) {
                    if ({}.hasOwnProperty.call(v1, $28)) {
                        $27[$28] = v1[$28];
                    };
                };
                $27.logs = v.value0;
                return $27;
            }))(function () {
                return pure1(new Data_Maybe.Just(v.value1));
            });
        };
        throw new Error("Failed pattern match at Foliage.App.Console.Component (line 38, column 17 - line 44, column 20): " + [ v.constructor.name ]);
    };
    var handleAction = function (v) {
        if (v instanceof MouseEnterLogHeader) {
            return discard(Data_Maybe.maybe(pure1(Data_Unit.unit))(function (env) {
                return Halogen_Query_HalogenM.raise(new ShowIntermediateEnv(env));
            })(v.value0))(function () {
                return pure1(Data_Unit.unit);
            });
        };
        if (v instanceof MouseLeaveLogHeader) {
            return discard(Halogen_Query_HalogenM.raise(HideIntermediateEnv.value))(function () {
                return pure1(Data_Unit.unit);
            });
        };
        throw new Error("Failed pattern match at Foliage.App.Console.Component (line 46, column 18 - line 52, column 16): " + [ v.constructor.name ]);
    };
    var $$eval = Halogen_Component.mkEval({
        receive: Halogen_Component.defaultEval.receive,
        initialize: Halogen_Component.defaultEval.initialize,
        finalize: Halogen_Component.defaultEval.finalize,
        handleQuery: handleQuery,
        handleAction: handleAction
    });
    return Halogen_Component.mkComponent({
        initialState: initialState,
        "eval": $$eval,
        render: render
    });
})();
export {
    AddLog,
    SetLogs,
    ShowIntermediateEnv,
    HideIntermediateEnv,
    MouseEnterLogHeader,
    MouseLeaveLogHeader,
    component
};
